module.exports = __webpack_public_path__ + "img/IMG_4215_L_Foamcore_MockedUp.02414c2a.jpg";